<script setup lang="ts">
import { usePage } from "@inertiajs/vue3"

import { ICON } from "@/lib/icons"
import {
  morePath,
  superAdminAccountsPath,
  superAdminUsersPath,
  superAdminSettingsPath,
  superAdminExportsPath,
} from "@/routes"

const page = usePage()

const tabs = [
  { label: "Accounts", to: superAdminAccountsPath() },
  { label: "Users", to: superAdminUsersPath() },
  { label: "Settings", to: superAdminSettingsPath() },
  { label: "Backups", to: superAdminExportsPath() },
]

function isActive(to: string) {
  return page.url.startsWith(to)
}
</script>

<template>
  <UApp>
    <div class="flex min-h-dvh flex-col">
      <header class="sticky top-0 z-40 border-b bg-(--ui-bg)/95 pt-[var(--safe-top)] backdrop-blur">
        <div class="mx-auto flex h-14 max-w-2xl items-center justify-between px-4">
          <span class="text-highlighted text-sm font-semibold tracking-tight">Super Admin</span>
          <UButton
            :icon="ICON.back"
            label="Back to app"
            :to="morePath()"
            variant="link"
            color="neutral"
            size="sm"
          />
        </div>

        <nav class="border-t">
          <div class="mx-auto flex max-w-2xl px-4">
            <UButton
              v-for="tab in tabs"
              :key="tab.to"
              :label="tab.label"
              :to="tab.to"
              variant="link"
              :color="isActive(tab.to) ? 'primary' : 'neutral'"
              size="sm"
              class="rounded-none border-b-2 px-4 py-2.5"
              :class="[
                isActive(tab.to)
                  ? 'border-(--ui-primary)'
                  : 'border-transparent hover:border-(--ui-border)',
              ]"
            />
          </div>
        </nav>
      </header>

      <main class="flex-1 pb-8">
        <div class="mx-auto max-w-2xl px-4 py-6">
          <slot />
        </div>
      </main>
    </div>
  </UApp>
</template>
